export const qaLabelResetPassword = {
    newPasswordInput: 'reset-password--new-password',
    confirmNewPasswordInput: 'reset-password--confirm-password',
    submitButton: 'reset-password--submit-button',
    errorMessage: 'reset-password--error-message',
    passwordChangeSuccessTitleMessage: 'reset-password--success-message--title',
    passwordChangeSuccessSubtitleMessage: 'reset-password--success-message--subtitle'
};
